import { html, unsafeCSS } from 'lit';
import { property, customElement } from 'lit/decorators.js';

import { PopBaseComponent } from '../../base/pop-base-component.js';
import style from './no-data-available.scss?inline';
import { Constants } from './no-data-available.constants.js';

/**
 * @tag pop-no-data-available-component
 */
@customElement(Constants.TAG_NAME)
export class PopNoDataAvailableComponent extends PopBaseComponent {
  static get styles() {
    return [...super.styles, unsafeCSS(style)];
  }

  /**
   * @internal
   */
  static readonly tagName = Constants.TAG_NAME;

  /**
   * Message to display when no data is available
   * @type string
   */
  @property({ attribute: Constants.DATA_MESSAGE, type: String })
  message = Constants.DEFAULT_MESSAGE;

  render() {
    return this.renderComponent(
      html`<section class="no-data-available-content">
        <span class="no-data-available-text">${this.message}</span>
      </section>`,
    );
  }
}
